<script lang="ts">
  // Utils
  import { SCREENS } from "$lib/utils/responsive"
  // Stores
  import { getCarouselContext, setupContext } from "$lib/utils/section-carousel"
  
  // Props
  export let id: string | null = null;
  export let mobileCount = 1
  export let desktopCount = 1
  export let duration = 0 // 0 = no timer
  export let desktopBreakpoint: keyof typeof SCREENS = "md"

  // Context
  setupContext()

  // Register
  const { carousels, registerCarousel, refreshPages } = getCarouselContext()
  $: {
    if (!(id in $carousels)) {
      registerCarousel(id, { mobileCount, desktopCount, desktopBreakpoint: SCREENS[desktopBreakpoint], duration })
    }
  }
</script>

<svelte:window on:resize="{refreshPages}" />

<slot />
